export default {
    tab: 'main',
    loading: false,
}